// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export var EActiveRoomType = /*#__PURE__*/function (EActiveRoomType) {
  /** Койко-место **/
  EActiveRoomType["Bed"] = "bed";
  /** Пятикомнатная квартира **/
  EActiveRoomType["FiveRoom"] = "fiveRoom";
  /** Четырехкомнатная квартира **/
  EActiveRoomType["FourRoom"] = "fourRoom";
  /** Многокомнатная квартира (6 и более комнат) **/
  EActiveRoomType["Large"] = "large";
  /** Однокомнатная квартира **/
  EActiveRoomType["OneRoom"] = "oneRoom";
  /** Квартира со свободной планировкой **/
  EActiveRoomType["OpenPlan"] = "openPlan";
  /** Комната **/
  EActiveRoomType["Room"] = "room";
  /** Доля в квартире **/
  EActiveRoomType["Share"] = "share";
  /** Студия **/
  EActiveRoomType["Studio"] = "studio";
  /** Трехкомнатная квартира **/
  EActiveRoomType["ThreeRoom"] = "threeRoom";
  /** Двухкомнатная квартира **/
  EActiveRoomType["TwoRoom"] = "twoRoom";
  return EActiveRoomType;
}({});
export var EAvailableRoomTypes = /*#__PURE__*/function (EAvailableRoomTypes) {
  /** Койко-место **/
  EAvailableRoomTypes["Bed"] = "bed";
  /** Пятикомнатная квартира **/
  EAvailableRoomTypes["FiveRoom"] = "fiveRoom";
  /** Четырехкомнатная квартира **/
  EAvailableRoomTypes["FourRoom"] = "fourRoom";
  /** Многокомнатная квартира (6 и более комнат) **/
  EAvailableRoomTypes["Large"] = "large";
  /** Однокомнатная квартира **/
  EAvailableRoomTypes["OneRoom"] = "oneRoom";
  /** Квартира со свободной планировкой **/
  EAvailableRoomTypes["OpenPlan"] = "openPlan";
  /** Комната **/
  EAvailableRoomTypes["Room"] = "room";
  /** Доля в квартире **/
  EAvailableRoomTypes["Share"] = "share";
  /** Студия **/
  EAvailableRoomTypes["Studio"] = "studio";
  /** Трехкомнатная квартира **/
  EAvailableRoomTypes["ThreeRoom"] = "threeRoom";
  /** Двухкомнатная квартира **/
  EAvailableRoomTypes["TwoRoom"] = "twoRoom";
  return EAvailableRoomTypes;
}({});